import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ArrowLeft, Info, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { CopyRoutineInfoCard } from "./CopyRoutineInfoCard";

interface SearchHeaderProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  showInfoButton?: boolean;
}

export const SearchHeader = ({ searchQuery, setSearchQuery, showInfoButton = false }: SearchHeaderProps) => {
  const navigate = useNavigate();
  const [infoOpen, setInfoOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            className="bg-primary/10 text-primary hover:bg-primary hover:text-primary-foreground transition-colors"
            onClick={() => navigate("/rutina")}
          >
            <ArrowLeft className="mr-2 h-4 w-4 sm:h-5 sm:w-5" />
            Volver
          </Button>
          <h1 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold whitespace-nowrap text-primary">
            Rutinas y Planes
          </h1>
          {showInfoButton && (
            <button
              type="button"
              onClick={() => setInfoOpen((v) => !v)}
              aria-label="¿Cómo copiar una rutina?"
              aria-expanded={infoOpen}
              className="rounded-full p-1.5 text-primary hover:bg-primary/10 transition"
            >
              <Info className="h-5 w-5" />
            </button>
          )}
        </div>
      </div>

      {showInfoButton && <CopyRoutineInfoCard open={infoOpen} onClose={() => setInfoOpen(false)} />}

      <div className="relative max-w-xl mx-auto mb-4">
        <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground h-5 w-5" />
        <Input
          type="search"
          placeholder="Buscar rutinas o planes..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-12 py-6 rounded-2xl bg-muted/40 backdrop-blur-sm border-border/60 text-foreground placeholder:text-muted-foreground text-base focus-visible:ring-primary/30 focus-visible:border-primary/50 shadow-sm"
        />
      </div>
    </>
  );
};
